import { AdminTeamUserPermissions } from './orgUser';

export const CSPermissions = {
    ...AdminTeamUserPermissions,
};
